<script setup lang="ts">
import BaseIcon from '@/components/base/baseIcon.vue'
import { iconNames } from '@/enums/iconNames'
import { pageNames } from '@/enums/pageNames'
import { userProfileStore } from '@/stores/user/userProfile'
import moment from 'moment'
import { onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'
const currentDateTime = ref<moment.Moment>(moment())
const showUserMenu = ref<boolean>(false)

const userProfile = userProfileStore()
const router = useRouter()

const img_url = import.meta.env.VITE_IMG_URL

function handleClickOutside(event: MouseEvent) {
  if(!(event.target as HTMLElement).closest('#dropdownTrigger') && !(event.target as HTMLElement).closest('.menu-button')) {
    showUserMenu.value = false
  }
}

setInterval(() => {
  currentDateTime.value = moment()
}, 1000)

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>
<template>
  <div class="hidden md:block bg-white relative">
    <div class="flex flex-row-reverse p-6 h-26 justify-between">
      <!-- <InputSearch type="text" placeholder="Type here" class="w-60 lg:w-80"></InputSearch> -->
      <div class="flex">
        <div class="flex px-1.5 2xl:px-5 py-2 border border-slate-400 rounded-lg mr-4 ml-auto">
          <img :src="'/vectors/headers/headerDate.svg'" width="20px" height="20px" />
          <div class="my-auto pr-0 pl-2 lg:pr-1.5">
            <p class="font-semibold text-xs">{{ currentDateTime.format('dddd') }},</p>
            <p class="font-normal text-ss">
              {{ currentDateTime.format('D MMMM YYYY - HH:mm') }}
            </p>
          </div>
        </div>
        <!-- <div class="flex px-1.5 border border-slate-400 rounded-lg">
          <img
            :src="'/vectors/headers/headerNotification.svg'"
            width="20px"
            height="20px"
            class="mr-2"
          />
          <div class="my-auto px-1.5 py-1 bg-header-notification rounded-full">
            <p class="font-normal text-ss text-white">9999</p>
          </div>
        </div> -->
        <div class="border-l-[1px] border-slate-200 mx-3 lg:mx-4"></div>
        <div id="dropdownTrigger" class="flex gap-2 cursor-pointer" @click="showUserMenu = !showUserMenu">
          <div class="flex">
            <img
              :src="
                userProfile.getUserProfile.thumbnail
                  ? img_url + userProfile.getUserProfile.thumbnail
                  : '/img/default-avatar.png'
              "
              class="rounded-xl mr-4 w-[48px] h-[48px]"
            />
            <div class="mr-[16px] hidden xl:block">
              <div class="text-[16px] font-semibold">
                {{ userProfile.getUserProfile.fullname || '' }}
              </div>
              <div class="text-[12px]">
                {{ userProfile.getUserProfile.email || '' }}
              </div>
            </div>
          </div>
          <div class="flex items-center">
            <img
              :src="'/vectors/headers/headerProfileDown.svg'"
              width="20px"
              height="20px"
              v-show="!showUserMenu"
            />
            <BaseIcon :icon-name="iconNames.UP" v-show="showUserMenu" />
          </div>
        </div>
      </div>
    </div>
    <div class="relative top-[16px] hidden md:block">
      <Transition>
        <div
          class="absolute right-[32px] w-[224px] bg-white p-[16px] rounded-b-[8px] shadow-lg z-200 user-menu"
          v-show="showUserMenu"
        >
          <div class="flex flex-col gap-[16px]">
            <button
              class="flex flex-row items-center p-[8px] hover:bg-[--algo-brand-violet-100] rounded-[6px]"
              type="button"
              @click="router.push({ name: pageNames.USERPROFILE })"
            >
              <span class="grow text-left font-medium">My Account</span>
              <BaseIcon :icon-name="iconNames.USER" />
            </button>
            <button
              @click="() => router.push({ name: pageNames.LOGOUT })"
              class="flex flex-row items-center p-[8px] hover:bg-[--algo-brand-violet-100] rounded-[6px]"
            >
              <span class="grow text-left font-medium">Log Out</span>
              <BaseIcon :icon-name="iconNames.SIGNOUT" />
            </button>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>
